// Trigger haptics on iOS devices. Requires the TapticEngine plugin to be installed.
export const triggerHapticFeedback = () => {
  if ((window as any).TapticEngine) {
    (window as any).TapticEngine.impact({
      style: "medium" // light | medium | heavy | rigid (iOS 13+) | soft (iOS 13+)
    });
  }
};